import { Box, CircularProgress, Paper, Stack } from "@mui/material";
import { httpsCallable } from "firebase/functions";
import { functions } from "firebaseApp";
import React, { useEffect, useState } from "react";

export default function ImageAutoUploader({ image, setImage, previewSize = 200, onClick = () => {} }) {

  const [uploading, setUploading] = useState(!Boolean(image?.imageUrl));

  const uploadImage = async () => {
    if (!image) return;
    if (!image.base64) return;
    if (image.imageUrl) return;
    try {
      setUploading(true);
      const response = await httpsCallable(
        functions,
        "uploadBase64Images"
      )({
        images: [image.base64],
      });
      const [imageData] = response.data.images;
      console.log(imageData);
      setImage(imageData);
    } catch (error) {
      console.log(error);
    } finally {
      setUploading(false);
    }
  };

  useEffect(() => {
    uploadImage();
  }, []);

  return (
    <Paper>
      <Stack
        alignItems="center"
        justifyContent="center"
        width={`${previewSize}px`}
        height={`${previewSize}px`}
        position="relative"
        sx={{
          cursor: "pointer",
          opacity: image.uploading ? 0.5 : 1,
        }}
        onClick={onClick}
        // onClick={() =>
        //   setPreview({
        //     ...image,
        //     uploadImage,
        //   })
        // }
        // onMouseEnter={() => setHover(true)}
        // onMouseLeave={() => setHover(false)}
      >
        <Box
          component="img"
          src={image.base64 || image.imageUrl}
          alt={`Image`}
          sx={{
            maxWidth: `${previewSize}px`,
            maxHeight: `${previewSize}px`,
            objectFit: "contain",
          }}
        />
        <Stack
          alignItems="center"
          justifyContent="center"
          position="absolute"
          width="100%"
          height="100%"
          left="0"
          top="0"
        >
          {uploading && <CircularProgress size={24} color="secondary" />}
          {/* {image.error && (
            <Button
              color="error"
              onClick={uploadImage}
              startIcon={<ReplayIcon />}
            >
              Retry
            </Button>
          )} */}
          {/* {hover && !image.error && <SearchIcon color="secondary" />} */}
        </Stack>
      </Stack>
    </Paper>
  );
}
